module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_1.63800f4f54f1c759575532a4be79e3f4.png";